import { computed, Injectable, signal } from '@angular/core';
import { PaginationResponse } from '@iq-central-front-end/share';

export interface DepartmentState {
    departments: any[] | null;
    department: any | null;
    loading: boolean;
    error: string | null;
}

@Injectable({ providedIn: 'root' })
export class DepartmentStore {
    private readonly state = signal<DepartmentState>({
        departments: null,
        department: null,
        loading: false,
        error: null,
    });

    readonly departments$ = computed(() => this.state().departments);
    readonly department$ = computed(() => this.state().department);
    readonly loading$ = computed(() => this.state().loading);
    readonly error$ = computed(() => this.state().error);

    setLoading(loading: boolean): void {
        this.state.update((state) => ({ ...state, loading }));
    }

    setError(error: string | null): void {
        this.state.update((state) => ({ ...state, error }));
    }

    setDepartments(departments: any[]): void {
        this.state.update((state) => ({ ...state, departments, loading: false }));
    }

    setDepartment(department: any): void {
        this.state.update((state) => ({
            ...state,
            department,
            loading: false,
        }));
    }

    addDepartment(department: any): void {
        this.state.update((state) => ({
            ...state,
            departments: state.departments ? [...state.departments, department] : [department],
            loading: false,
        }));
    }

    updateDepartment(updatedDepartment: any): void {
        this.state.update((state) => ({
            ...state,
            departments: state.departments?.map(dept =>
                dept.id === updatedDepartment.id ? updatedDepartment : dept
            ) || null,
            department: state.department?.id === updatedDepartment.id ? updatedDepartment : state.department,
            loading: false,
        }));
    }

    deleteDepartment(departmentId: string): void {
        this.state.update((state) => ({
            ...state,
            departments: state.departments?.filter(dept => dept.id !== departmentId) || null,
            department: state.department?.id === departmentId ? null : state.department,
            loading: false,
        }));
    }

    clearError(): void {
        this.state.update((state) => ({ ...state, error: null }));
    }

    reset(): void {
        this.state.set({
            departments: null,
            department: null,
            loading: false,
            error: null,
        });
    }
} 